// src/apsales/EditProject/index.tsx
import AddEditProject from "@/apsales/Projects/AddEditProject";
export default function EditProject() {
    return <AddEditProject mode="edit" />;
}
